/**
 * useGreeting Hook — 演示 Hook 注册
 *
 * 一个简单的问候语 Hook，展示如何注册和消费跨模块 Hook。
 */
import { useCallback, useState } from 'react';
/**
 * useGreeting Hook
 *
 * @param initialName 初始名称
 * @returns 问候语状态和更新函数
 */
export function useGreeting(initialName = 'World') {
    const [name, setName] = useState(initialName);
    const [count, setCount] = useState(0);
    const greet = useCallback(() => {
        setCount(c => c + 1);
        return `Hello, ${name}! (greeted ${count + 1} times)`;
    }, [name, count]);
    const reset = useCallback(() => {
        setName(initialName);
        setCount(0);
    }, [initialName]);
    return {
        name,
        count,
        greeting: `Hello, ${name}!`,
        greet,
        setName,
        reset,
    };
}
//# sourceMappingURL=use-greeting.js.map